import type { BriefGateway, SubmissionReceipt } from '@/application/brief/BriefGateway';
import type { Brief } from '@/domain/brief/Brief';
import type { HttpClient } from '@/infrastructure/http/HttpClient';

/** Réponse attendue de `POST /v1/briefs` côté API Go. */
interface CreateBriefResponse {
  readonly reference: string;
  readonly received_at: string;
}

export class HttpBriefGateway implements BriefGateway {
  private readonly http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  async submit(brief: Brief, signal?: AbortSignal): Promise<SubmissionReceipt> {
    const response = await this.http.postJson<CreateBriefResponse>(
      '/v1/briefs',
      brief.toPayload(),
      signal ? { signal } : {},
    );
    return { reference: response.reference, receivedAt: new Date(response.received_at) };
  }
}
